<template>
  <div
    v-if="productName"
    class="body-right product-history-detail-mobile product-history-detail"
  >
    <div class="title-body-right">
      <h1 class="title-page" @click="backtoProductHistory()">
        <i class="el-icon-arrow-left icon" />
        {{ productName.name }}
      </h1>

      <div class="group-btn">
        <el-button
          class="btn btn-search-sp"
          type="primary"
          @click="toggleSearchBlock()"
        >
          {{ $t('common.toggleMenu') }}
        </el-button>

        <el-button class="search-mobile" type="primary" @click="onSubmit">
          {{ $t('product.searchBtn') }}
        </el-button>
      </div>
    </div>

    <el-form
      :inline="true"
      :model="search"
      class="form container-search"
      :class="openSearchForm ? 'visible' : 'hidden'"
      @submit.native.prevent
      @keyup.enter.native="onSubmit()"
    >
      <el-form-item class="form-date date-from" prop="fromDate">
        <el-date-picker
          type="date"
          :placeholder="$t('product.startDate')"
          v-model="search.fromDate"
          style="width: 100%"
          :editable="false"
          :picker-options="pickerBeginDateBefore"
        >
        </el-date-picker>
      </el-form-item>

      <span class="tilde">~</span>

      <el-form-item class="form-date date-to" prop="toDate">
        <el-date-picker
          type="date"
          :placeholder="$t('product.endDate')"
          v-model="search.toDate"
          style="width: 100%"
          :editable="false"
          :picker-options="pickerBeginDateAfter"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="fullsize-input-sp">
        <el-autocomplete
          class="input fullsize-input-sp"
          popper-class="popper-drop-down"
          :placeholder="$t('productHistory.username')"
          v-model="search.userName"
          :popper-append-to-body="false"
          :fetch-suggestions="remoteUserMethod"
          @select="handleSelectUser"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-circle-close el-input__clear"
            @click="search.userName = ''"
            v-if="search.userName"
          >
          </i>
        </el-autocomplete>
      </el-form-item>

      <el-form-item>
        <v-select
          class="form-select v-select-search search-product"
          :searchable="false"
          v-model="search.actionType"
          :placeholder="$t('productHistory.operate')"
          :options="[
            ...[...EOperationStatus.getKeys()].map((key) => ({
              label: key,
              value: EOperationStatus.getValue(key),
            })),
          ]"
          ><template #open-indicator="{ attributes }">
            <img
              v-bind="attributes"
              src="@/assets/images/down-icon.png"
              class="down-icon"
              :class="search.actionType && `selected`"
            /> </template
          ><template #no-options="">
            {{ $t('common.emptyText') }}
          </template></v-select
        >
      </el-form-item>

      <div class="button search-pc history-search">
        <el-form-item>
          <el-button class="search-button" type="primary" @click="onSubmit">
            {{ $t('product.searchBtn') }}
          </el-button>
        </el-form-item>
      </div>
    </el-form>

    <el-row
      class="total-table"
      :class="openSearchForm ? 'total-table-absolute' : ''"
    >
      <el-col :xs="12">
        {{ $t('user.total') }}: {{ productHistoryDetail.total }}
      </el-col>
    </el-row>

    <table-list
      :dataColumn="productHistoryDetail.data"
      :currentPage="productHistoryDetail.currentPage"
    />

    <div class="pagination">
      <base-pagination
        :totalPage="productHistoryDetail.total"
        @changePage="changeCurrentPage"
        :currentPage="+$route.query.page"
      >
      </base-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { LIMIT, PAGE } from '@/constants/common';
import { redirectRouter, trimValue, formatDate, formatNumber } from '@/helper';
const BasePagination = () => import('@/components/BasePagination');
import * as pageRouter from '@/constants/pageRouter';

const TableList = () => import('./TableList');
import { EOperationStatus } from '@/enums/user';

export default {
  name: 'ListProductHistoryDetail',
  components: {
    BasePagination,
    TableList,
  },
  data() {
    return {
      userAutoComplete: {
        label: '',
        options: [],
      },
      search: {
        fromDate: undefined,
        toDate: undefined,
        userName: undefined,
        page: PAGE,
        limit: LIMIT,
      },
      formLabelWidth: '120px',
      openSearchForm: true,
      EOperationStatus,
      pickerBeginDateBefore: {
        disabledDate: (time) => {
          let beginDateVal = this.search.toDate;
          if (beginDateVal) {
            return time.getTime() > beginDateVal;
          }
        },
      },
      pickerBeginDateAfter: {
        disabledDate: (time) => {
          let beginDateVal = this.search.fromDate;
          if (beginDateVal) {
            return time.getTime() < beginDateVal;
          }
        },
      },
    };
  },
  created() {
    this.search = {
      ...this.search,
      ...this.$router.currentRoute.query,
      actionType: this.$router.currentRoute.query.actionType && {
        label: EOperationStatus.getKey(
          +this.$router.currentRoute.query.actionType
        ),
        value: this.$router.currentRoute.query.actionType,
      },
      limit: LIMIT,
    };

    this.getProductHistoryDetail({
      id: this.$route.params.id,
      params: {
        ...this.search,
        actionType: this.search.actionType && this.search.actionType.value,
      },
    });

    this.getProductName({
      id: this.$route.params.id,
    });
  },
  computed: {
    ...mapGetters('product', ['productHistoryDetail']),
    ...mapGetters('product', ['productName']),
    ...mapGetters('user', ['user']),
    mapUserData() {
      return this.user.data.map((item) => ({
        id: item.id,
        value: item.userName,
      }));
    },
  },
  methods: {
    ...mapActions('user', ['getUserList']),
    ...mapActions('product', ['getProductHistoryDetail']),
    ...mapActions('product', ['getProductName']),
    formatNumber,
    async onSubmit() {
      this.search = {
        ...trimValue({ ...this.search }),
        page: PAGE,
        limit: LIMIT,
        fromDate: this.search.fromDate
          ? formatDate(this.search.fromDate)
          : undefined,
        toDate: this.search.toDate ? formatDate(this.search.toDate) : undefined,
      };

      this.getProductHistoryDetail({
        id: this.$route.params.id,
        params: {
          ...this.search,
          actionType: this.search.actionType && this.search.actionType.value,
        },
      });

      redirectRouter({
        path: `/product-history/${this.$route.params.id}`,
        query: {
          ...this.search,
          actionType: this.search.actionType && this.search.actionType.value,
        },
      });
    },
    toggleSearchBlock() {
      this.openSearchForm = !this.openSearchForm;
    },
    changeCurrentPage(e) {
      this.search = {
        ...this.$router.currentRoute.query,
        actionType: this.$router.currentRoute.query.actionType && {
          label: EOperationStatus.getKey(
            +this.$router.currentRoute.query.actionType
          ),
          value: this.$router.currentRoute.query.actionType,
        },
        page: e.page,
        limit: LIMIT,
      };

      this.getProductHistoryDetail({
        id: this.$route.params.id,
        params: {
          ...this.search,
          actionType: this.search.actionType && this.search.actionType.value,
        },
      });

      redirectRouter({
        path: `/product-history/${this.$route.params.id}`,
        query: {
          ...this.search,
          actionType: this.search.actionType && this.search.actionType.value,
          page: this.search.page || undefined,
        },
      });
    },

    async remoteUserMethod(query, cb) {
      await this.getUserList({
        userName: query,
      });
      this.userAutoComplete.options = this.mapUserData || [];

      cb(this.userAutoComplete.options);
    },

    handleSelectUser(item) {
      this.search.userName = item.value;
    },
    backtoProductHistory() {
      redirectRouter({
        path: pageRouter.PRODUCT_HISTORY,
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/common.scss';
@import './styles.module.scss';

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  _::-webkit-full-page-media,
  _:future,
  :root,
  .vs__search {
    padding-left: 14px;
  }
}
</style>
